import { func, number, shape, bool } from 'prop-types';
import React from 'react';
import BundleItemComponent from 'components/BundleItemComponent';
import ErrorBoundary from 'components/ErrorBoundary';
// Base components
import Ad from 'components/Ad';
import DetectAdBlock from 'components/DetectAdBlock';
import EmailSignup from 'components/EmailSignup';
import Faq from 'components/Faq';
import Figure from 'components/Figure';
import Html from 'components/Html';
import ImageSlider from 'components/ImageSlider';
import Listicle from 'components/Listicle';
import Product from 'components/Product';
import ProductTeaser from 'components/ProductTeaser';
import ProductTeaserList from 'components/ProductTeaserList';
import RecipeFirst from 'components/RecipeFirst';
import RecipeRoundup from 'components/RecipeRoundup';
import SideBySide from 'components/SideBySide';
import SiteRecipe from 'components/SiteRecipe';
import SlideGallery from 'components/SlideGallery';
import SubsectionNav from 'components/SubsectionNav';
import Tip from 'components/Tip';
import ThirdPartyEmbed from 'components/ThirdPartyEmbed';
import Video from 'components/Video';
// AMP components
import AmpAd from 'components/AmpAd';
import AmpEmailSignup from 'components/AmpEmailSignup';
import AmpFaq from 'components/AmpFaq';
import AmpGallery from 'components/AmpGallery';
import AmpHtml from 'components/AmpHtml';
import AmpImg from 'components/AmpImg';
import AmpImageSlider from 'components/AmpImageSlider';
import AmpListicle from 'components/AmpListicle';
import AmpProductTeaserList from 'components/AmpProductTeaserList';
import AmpRecipe from 'components/AmpRecipe';
import AmpRecipeRoundup from 'components/AmpRecipeRoundup';
import AmpSideBySide from 'components/AmpSideBySide';
import AmpSubsectionNav from 'components/AmpSubsectionNav';
import AmpThirdPartyEmbed from 'components/AmpThirdPartyEmbed';
import AmpVideo from 'components/AmpVideo';

const AMP_POST_COMPONENTS = {
  ad: AmpAd,
  emailSignup: AmpEmailSignup,
  faq: AmpFaq,
  gallery: AmpGallery,
  heading: AmpHtml,
  html: AmpHtml,
  image: AmpImg,
  imageSlider: AmpImageSlider,
  inPostVideoAd: AmpVideo,
  listicle: AmpListicle,
  product: Product,
  productEmbed: ProductTeaser,
  productTeaser: ProductTeaser,
  productTeaserList: AmpProductTeaserList,
  recipe: AmpRecipe,
  recipeCollection: AmpRecipeRoundup,
  sideBySide: AmpSideBySide,
  subsectionNav: AmpSubsectionNav,
  tip: Tip,
  thirdParty: AmpThirdPartyEmbed,
  video: AmpVideo
};

const BASE_POST_COMPONENTS = {
  ad: Ad,
  emailSignup: EmailSignup,
  faq: Faq,
  gallery: SlideGallery,
  heading: Html,
  html: Html,
  image: Figure,
  imageSlider: ImageSlider,
  inPostVideoAd: Video,
  listicle: Listicle,
  product: Product,
  productEmbed: ProductTeaser,
  productTeaser: ProductTeaser,
  productTeaserList: ProductTeaserList,
  railVideoAd: props => (
    <DetectAdBlock>
      {({ isAdBlockDetected }) =>
        isAdBlockDetected ? null : <Video {...props} />
      }
    </DetectAdBlock>
  ),
  recipe: SiteRecipe,
  recipeFirst: RecipeFirst,
  recipeCollection: RecipeRoundup,
  sideBySide: SideBySide,
  subsectionNav: SubsectionNav,
  tip: Tip,
  thirdParty: ThirdPartyEmbed,
  video: Video
};

function PostBundleItem({ item, customPropsMapper, idx, isAmp }) {
  // swap out default component mapping for an AMP component mapping when in AMP
  // mode.
  const components = isAmp ? AMP_POST_COMPONENTS : BASE_POST_COMPONENTS;

  return (
    <ErrorBoundary errorMessage={`Error: Unable to render ${item.type}`}>
      <BundleItemComponent
        item={item}
        idx={idx}
        customPropsMapper={customPropsMapper}
        components={components}
      />
    </ErrorBoundary>
  );
}

PostBundleItem.propTypes = {
  item: shape({}).isRequired,
  customPropsMapper: func.isRequired,
  idx: number.isRequired,
  isAmp: bool
};

PostBundleItem.defaultProps = {
  isAmp: false
};

export default PostBundleItem;
